function getQuickViewWrapper() {
  return document.getElementById("quickViewWrapper");
}

/* CIVETTA FIX: Force Quick View images to load after dynamic fetch */
function civettaFixQuickViewImages(scope) {
  if (!scope) return;

  scope.querySelectorAll("source").forEach(function (source) {
    var dataSrcset =
      source.getAttribute("data-srcset") ||
      source.getAttribute("data-lazy-srcset") ||
      source.dataset.srcset;

    if (dataSrcset && !source.getAttribute("srcset")) {
      source.setAttribute("srcset", dataSrcset);
    }
  });

  scope.querySelectorAll("img").forEach(function (img) {
    img.setAttribute("loading", "eager");

    img.classList.remove("lazyload");
    img.classList.remove("lazyloading");

    var dataSrc =
      img.getAttribute("data-src") ||
      img.getAttribute("data-lazy-src") ||
      img.getAttribute("data-original") ||
      img.dataset.src;

    var dataSrcset =
      img.getAttribute("data-srcset") ||
      img.getAttribute("data-lazy-srcset") ||
      img.dataset.srcset;

    var dataSizes =
      img.getAttribute("data-sizes") ||
      img.dataset.sizes;

    var currentSrc = img.getAttribute("src") || "";

    if (dataSrcset && !img.getAttribute("srcset")) {
      img.setAttribute("srcset", dataSrcset);
    }

    if (dataSizes && !img.getAttribute("sizes")) {
      img.setAttribute("sizes", dataSizes);
    }

    if (
      dataSrc &&
      (
        !currentSrc ||
        currentSrc.includes("data:image") ||
        currentSrc.includes("placeholder") ||
        currentSrc.includes("blank")
      )
    ) {
      img.setAttribute("src", dataSrc);
    }

    img.style.display = "block";
    img.style.visibility = "visible";
    img.style.opacity = "1";
    img.style.width = "100%";
    img.style.maxWidth = "100%";
    img.style.height = "auto";
    img.style.objectFit = "cover";
  });

  scope
    .querySelectorAll(
      ".quick_view__body, .product__media, .product__media-item, .product__media-list, .quick_view__media, .swiper, .swiper-wrapper, .swiper-slide, slider-component"
    )
    .forEach(function (el) {
      el.style.visibility = "visible";
      el.style.opacity = "1";
    });

  setTimeout(function () {
    window.dispatchEvent(new Event("resize"));
  }, 100);

  setTimeout(function () {
    window.dispatchEvent(new Event("resize"));
  }, 500);
}

function civettaCloseQuickView() {
  var quickViewWarpper = getQuickViewWrapper();
  if (!quickViewWarpper) return;

  document.body.classList.remove("overflow-hidden");
  quickViewWarpper.classList.remove("show__modal");

  document
    .querySelectorAll("quick-view-modal button.active, .cart--icon-button.active")
    .forEach(function (button) {
      button.classList.remove("active");
    });

  if (typeof removeTrapFocus === "function") {
    removeTrapFocus();
  }
}

class quickViewModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClickQuickViewModal);
  }

  onClickQuickViewModal = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    var quickViewWarpper = getQuickViewWrapper();
    var quickViewModal = this.querySelector("button");

    if (!quickViewWarpper || !quickViewModal) return;

    var productHandle = quickViewModal.dataset.productHandle;
    if (!productHandle) return;

    quickViewModal.classList.add("loading");

    try {
      const response = await fetch(`/products/${productHandle}?view=quickview`, {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      if (!response.ok) {
        throw new Error("Quick view request failed");
      }

      const resText = await response.text();

      quickViewWarpper.innerHTML = resText;

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      document.body.classList.add("overflow-hidden");
      quickViewWarpper.classList.add("show__modal");

      document.querySelectorAll("quick-view-modal button.active").forEach(function (button) {
        button.classList.remove("active");
      });

      quickViewModal.classList.add("active");

      civettaFixQuickViewImages(quickViewWarpper);

      setTimeout(function () {
        civettaFixQuickViewImages(quickViewWarpper);
      }, 300);

      setTimeout(function () {
        civettaFixQuickViewImages(quickViewWarpper);
      }, 800);

      setTimeout(function () {
        civettaFixQuickViewImages(quickViewWarpper);
      }, 1200);
    } catch (error) {
      console.log("Quick view error:", error);
    } finally {
      quickViewModal.classList.remove("loading");

      if (
        typeof trapFocus === "function" &&
        quickViewWarpper.classList.contains("show__modal")
      ) {
        trapFocus(quickViewWarpper);
      }
    }
  };
}

if (!customElements.get("quick-view-modal")) {
  customElements.define("quick-view-modal", quickViewModal);
}

class quickViewCloseTag extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      civettaCloseQuickView();
    });
    this.currentVariant = {};
  }
}

if (!customElements.get("quick-view-close")) {
  customElements.define("quick-view-close", quickViewCloseTag);
}

document.addEventListener("keyup", function (evt) {
  var quickViewWarpper = getQuickViewWrapper();

  if (
    evt.code === "Escape" &&
    quickViewWarpper &&
    quickViewWarpper.classList.contains("show__modal")
  ) {
    civettaCloseQuickView();
  }
});

document.addEventListener("click", function (event) {
  var quickViewWarpper = getQuickViewWrapper();

  if (!quickViewWarpper || !quickViewWarpper.classList.contains("show__modal")) return;

  var clickedInsideQuickView = event.target.closest(".quick_view__body");
  var clickedQuickViewButton = event.target.closest("quick-view-modal");

  if (!clickedInsideQuickView && !clickedQuickViewButton) {
    civettaCloseQuickView();
  }
});

class QuickVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.getPreOrderVariantData();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(this.querySelectorAll(".product-form__input--dropdown")).map(
      (select, index) => {
        if (
          select.children &&
          select.children[0] &&
          select.children[0].children &&
          select.children[0].children[1]
        ) {
          select.children[0].children[1].innerHTML = this.options[index];
        }
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    const parent = newMedia.parentElement;

    if (parent.firstChild == newMedia) return;

    parent.prepend(newMedia);

    window.setTimeout(() => {
      parent.scroll(0, 0);
      civettaFixQuickViewImages(getQuickViewWrapper());
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      if (!input) return;

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("no-js-inline");

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        civettaFixQuickViewImages(getQuickViewWrapper());
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    let productVarArray = this.PreorderVariantData;
    let variant = this.currentVariant;
    let VarInventoryManagement =
      this.currentVariant?.inventory_management ?? null;
    let var_num = "";

    if (VarInventoryManagement != null && productVarArray && variant) {
      for (let variant_id in productVarArray) {
        if (variant.id == variant_id) {
          var_num = productVarArray[variant_id].qty;
          var inventoryQuantity = parseInt(var_num);
          var inventoryPolicy = productVarArray[variant_id].inventory_policy;
        }

        if (inventoryQuantity <= 0 && inventoryPolicy === "continue") {
          addButton.removeAttribute("disabled");
          addButton.textContent = window.variantStrings.preorder;
        } else if (inventoryQuantity <= 0 && inventoryPolicy !== "continue") {
          addButton.setAttribute("disabled", true);
          addButton.textContent = window.variantStrings.soldOut;
        } else {
          addButton.removeAttribute("disabled");
          addButton.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (!button) return;

    const addButton = button.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);

    if (!addButton) return;

    addButton.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add("no-js-inline");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-variant]").textContent);

    return this.variantData;
  }

  getPreOrderVariantData() {
    const preorderData = this.querySelector("[data-preorder]");

    if (!preorderData) {
      this.PreorderVariantData = {};
      return;
    }

    this.PreorderVariantData =
      this.PreorderVariantData ||
      JSON.parse(preorderData.textContent);
  }
}

if (!customElements.get("quick-variant-selects")) {
  customElements.define("quick-variant-selects", QuickVariantSelects);
}

class QuickVariantRadios extends QuickVariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.onColorSwatches();
  }

  onColorSwatches() {
    const swatchButtonList = this.querySelectorAll(
      `fieldset.variant--swatch-${this.dataset.colorSwatch} > label`
    );

    const result = Object.values(
      this.getVariantData().reduce((total, item) => {
        let k = `${item[this.dataset.colorSwatch]}`;

        if (!total[k]) {
          total[k] = { ...item, count: 1 };
        } else {
          total[k].count += 1;
        }

        return total;
      }, {})
    );

    swatchButtonList.forEach((button) => {
      result.forEach((data) => {
        if (data[this.dataset.colorSwatch] === button.dataset.value) {
          if (
            this.dataset.colorSwatchStyle === "image" &&
            data.featured_image !== null
          ) {
            button.setAttribute(
              "style",
              `--swatch-background-image: url(${
                data.featured_image.src
              }); --swatch-background-color: ${data[this.dataset.colorSwatch]};`
            );
          } else {
            button.setAttribute(
              "style",
              `--swatch-background-color: ${data[this.dataset.colorSwatch]};`
            );
          }
        }
      });
    });
  }

  updateOptions() {
    this.options = this.fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );

      return checkedRadio ? checkedRadio.value : "";
    });
  }

  updateOptionsParent() {
    this.fieldsets.map((fieldset, index) => {
      if (
        fieldset.children &&
        fieldset.children[0] &&
        fieldset.children[0].children &&
        fieldset.children[0].children[1]
      ) {
        fieldset.children[0].children[1].innerHTML = this.options[index];
      }
    });
  }
}

if (!customElements.get("quick-variant-radios")) {
  customElements.define("quick-variant-radios", QuickVariantRadios);
}